module.exports = __webpack_public_path__ + "img/monaco.82b149cc.svg";